<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em">I am indebted to the many people who read the manuscript during the long process of writing. They provided invaluable feedback. The list is too long to include all of them. However, there are several who warrant a special word of thanks.</p><br/>
<p style="text-indent:0em">First and foremost, is my harshest critic and the greatest source of encouragement with multiple suggestions and endless patience, my precious wife, Orit. Without her, this work would never have seen the light of day.</p><br/>
<p style="text-indent:0em">Jeff Wolfin supported me by reading the book and because of his excitement insisted on composing the outstanding synopsis.</p><br/>
<p style="text-indent:0em">Philippa Donovan of Smart Quill set me on the right track to writing fiction. She was consistent in utilising her professional expertise to make certain I never veered off the path.</p><br/>
<p style="text-indent:0em">Robin Wiseman, my brother has always been there for me throughout the long years of our sibling relationship. He has never flinched from telling me the truth. He honoured that commitment to our connection throughout by giving me honest feedback and offering priceless ideas.</p><br/>
<p style="text-indent:0em">Kevin Smith of Austin Macauley succeeded in keeping my spirits up whenever they were flagging. I truly appreciate his support.</p><br/>
<p style="text-indent:0em">Finally, I want to acknowledge and say thank you to the thousands of people I have met in the course of my life. Many of them were willing to share with me the joys and successes as well as the trials and tribulations of their lives. They provided the foundation on which Between Heaven and Earth is based.</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?ee231dfc